/* eslint-disable react/prop-types */
import React from "react";
import Loader from "react-loaders";

const FilterLoader = () => (
  <Loader active type="line-scale" style={{ transform: "scale(0.6)" }} />
);

export default FilterLoader;
